import LC from "@kugou/light-mobilecall";
const apis = {
  //上报用户入驻类型,http://doc.kugou.net/showdoc-master/web/#/11?page_id=7671
  logType: {
    url: '/v1/settle_log',
    method: 'post'
  },
  //获取用户入驻类型,http://doc.kugou.net/showdoc-master/web/#/11?page_id=7672
  getLogType: {
    url: '/v1/settle_log_info'
  },
  //获取用户人脸识别信息
  //http://doc.kugou.net/showdoc-master/web/#/11?page_id=6071
  get_face_status: {
    url: '/v1/verify/get_face_status'
  },

  // 基本配置获取接口
  getBaseConfig: {
    url: '/config/singerBaseInfo',
  },

  //获取用户账号信息
  getUserStatus: {
    url: '/account/getUserInfo'
  },


  //上传图片的接口
  uploadImg: {
    url: '/wxupload/fcgi-bin/fcg_upload_img.cgi',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    method: 'post'
  },


  //发送短信验证码
  sendSmsCode: {
    url: '/sms/sendVerify',
    method: 'post'
  },

  //获取入驻信息
  getEnterFormInfo: {
    url: '/settle/info'
  },

  //提交入驻信息
  upsertEnterForm: {
    url: '/settle/submit',
    method: 'post'
  },

  //获取认领信息
  getGotSingerEnterFormInfo: {
    url: '/claim/info'
  },

  //提交认领信息
  upsertGotSingerEnterForm: {
    url: '/claim/submit',
    method: 'post'
  },

  //已实名情况自动填写身份证及姓名
  //http://doc.kugou.net/showdoc-master/web/#/11?page_id=6388
  autoFillClaimSubmit:{
    url: 'v1/claim/submit',
    method: 'post'
  },

  //3.3.20 词曲入驻补充资料接口
  cqSupplement: {
    url: '/enter/cqsupplement',
    method: 'post'
  },

  //3.2.12 实名认证绑定账号-校验
  bindByRealPerson: {
    url: '/account/bindByRealPerson',
    method: 'post'
  },

  //
  getFaceAuth: {
    url: '/v1/verify/get_face_auth',
    method: 'post'
  },

  //校验邮箱
  checkMail: {
    url: '/check/mail'
  },

  //敏感词检测
  checkSensitive: {
    url: '/sensitive/word',
    method: 'post'
  },

  //歌手名校验
  checkSingerName: {
    url: '/settle/checkSingerName'
  },

  //证件号检测
  checkNum: {
    url: '/check/idcard'
  },

  //已实名自动检测
  autoCheckNum:{
    url: '/v1/check/idcard'
  },

  //身份证征信检测
  checkCredit: {
    url: '/check/credit'
  },

  //身份证ocr
  idcardCountrySideOcr: {
    url: '/idcard/front/ocr',
    method: 'post'
  },

  //身份证ocr
  idcardManSideOcr: {
    url: '/idcard/back/ocr',
    method: 'post'
  },


  //根据平台歌手Id查询歌手
  searchSingerById: {
    url: '/claim/searchSingerById'
  },

  //搜索歌手
  searchSinger: {
    url: '/claim/searchSingerV3'
  },

  //手机号绑定腾讯音乐人(旧)
  phoneBindMusician: {
    url: '/account/bindByPhone',
    method: 'post'
  },

  //文档3.2.8 通过手机号预绑定
  bindPhoneBefore: {
    url: '/account/bindPlatformAccount',
    method: 'post'
  },

  //文档3.2.9 确认手机号绑定
  bindPhoneConfirm: {
    url: '/account/bindPlatformAccountConfirm',
    method: 'post'
  },

  getPhoneBySingerId:{
    url: '/account/getPhoneBySingerId'
  },

  //检查歌手是否可以认领
  checkSingerCanGet: {
    url: '/claim/checkSinger'
  },

  //获取歌手详细信息
  getSingerDetail: {
    url: '/singer/info'
  },

  //3.3.18 获取最近一次审核不通过详情
  auditResult:{
    url: '/singer/auditResult'
  },

  //安全上传图片相关

  //获取签名
  getUploadSignature: {
    url: '/file/getCosSign',
    method: 'post'
  },

  //获取cos url
  getUploadCosUrl: {
    url: '/file/getFileUrl',
    method: 'post'
  },

  //酷狗自己的接口，查看音乐人认证状态
  // http://doc.kugou.net/showdoc-master/web/#/7?page_id=4256
  getMyKugouStarStatus: {
    url: '/v1/get_my_starstatus_wh'
  },
  
  //获取remix入驻内容的草稿数据，获取用户认领、入驻提交过的信息
  //http://doc.kugou.net/showdoc-master/web/#/35?page_id=6863
  remixInfo:{
    url: '/v1/dj/my_detail',
    headers:{
      'KG-TID': LC.isIOS ? 106 : 104
    }
  },
  
  //3.3.22 校园信息查询
  studentInfo: {
    url: '/settle/student/info'
  }
}

for (let api in apis) {
  apis[api].method = apis[api].method ? apis[api].method.toLowerCase() : 'get'
}

export default apis